import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/biotech-readiness")({
  head: () => buildRouteHead("/biotech-readiness", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/biotech-readiness", replace: true });
  },
});
